// extracted by mini-css-extract-plugin
export var imageWrapper = "lecture-module--imageWrapper--wsLh9";
export var wrapper = "lecture-module--wrapper--1pbdE";
export var linkText = "lecture-module--linkText--1-rt8";
export var description = "lecture-module--description--h7bWV";